import { columnHelper } from './helper';

export const imagePullPolicy = columnHelper.accessor('imagePullPolicy', {
  header: 'Image Pull Policy',
  id: 'imagePullPolicy',
});
